// Use this to initialise on document ready

$(document).ready(function() {
	'use strict';

    $('body').addClass('js-enabled');

    var accordions = $('.js-accordion');

    // Init external libraries

    var defaultConfig = {
        headersSelector: '.js-accordion-header',
        panelsSelector: '.js-accordion-panel',
        buttonsSelector: 'button.js-accordion-header',
        buttonsGeneratedContent: 'html',
        button: $('<button></button>', {
            class: 'js-accordion-header',
            type: 'button'
        }),
        buttonSuffixId: '_tab',
        multiselectable: true,
        prefixClass: 'accordion',
        headerSuffixClass: '-title',
        buttonSuffixClass: '-header',
        panelSuffixClass: '-panel',
        direction: 'ltr', // rtl
        accordionPrefixId: 'accordion'
    };

    if (accordions.length > 0) {
        accordions.accordion(defaultConfig);
    }

});
